function generatePointFeature(location) {
  const feature = {
    type: 'Feature',
    properties: {
      ...location,
      icon: location.status === 'Extended' ? 'plumPin' : 'redPin',
    },
    geometry: {
      type: 'Point',
      coordinates: [location.longitude, location.latitude, 0.0],
    },
  }
  return feature
}

export function generateGeoJSON(locations) {
  const geoJSON = {
    type: 'FeatureCollection',
    features: locations.map(location => {
      return generatePointFeature(location)
    }),
  }
  return geoJSON
}

export function getBoundsFromPoints(pointList) {
  return pointList.reduce(
    (box, point) => {
      const [lng, lat] = point
      const minLng = Math.min(box.south, lng)
      const minLat = Math.min(box.west, lat)
      const maxLng = Math.max(box.north, lng)
      const maxLat = Math.max(box.east, lat)
      return {
        south: minLng,
        west: minLat,
        north: maxLng,
        east: maxLat,
      }
    },
    { south: Infinity, west: Infinity, north: -Infinity, east: -Infinity }
  )
}

export function dispatchCustomEvent(eventName, eventDetail) {
  window.dispatchEvent(new CustomEvent(eventName, { detail: eventDetail }))
}
